export var valuesLineType = ["solid", "dashed", "dotted"];
//# sourceMappingURL=LineType.js.map